// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-static-side {
  z-index: 2001;
  position: absolute;
  width: 220px; }

.nav > li > span,
.nav > li > .sub-nav a {
  position: relative;
  display: block;
  padding: 10px 15px; }

.nav > li > .sub-nav a {
  padding-left: 30px; }

.nav .sub-nav li:last-child {
  border-bottom: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/no/motorgruppen/nav/Nav.scss"],"names":[],"mappings":"AAAA;EACC,aAAa;EACb,kBAAkB;EAClB,YAAY,EAAA;;AAGb;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB,EAAA;;AAEpB;EACE,kBAAkB,EAAA;;AAGpB;EAKM,gBAAgB,EAAA","sourcesContent":[".navbar-static-side {\n\tz-index: 2001;\n\tposition: absolute;\n\twidth: 220px;\n}\n\n.nav > li > span,\n.nav > li > .sub-nav a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n.nav > li > .sub-nav a {\n  padding-left: 30px;\n}\n\n.nav .sub-nav {\n  li {\n    // padding-left: 15px;\n\n    &:last-child {\n      border-bottom: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
